var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronRightEnd = function SvgChevronRightEnd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13456 11.9193C4.81112 12.1781 4.33915 12.1256 4.08039 11.8022C3.82163 11.4787 3.87408 11.0068 4.19752 10.748L7.53086 8.08134C7.80477 7.86221 8.19398 7.86221 8.4679 8.08134L11.8012 10.748C12.1247 11.0068 12.1771 11.4787 11.9184 11.8022C11.6596 12.1256 11.1876 12.1781 10.8642 11.9193L7.99938 9.62746L5.13456 11.9193ZM5.13456 7.91931C4.81112 8.17807 4.33915 8.12563 4.08039 7.80218C3.82163 7.47873 3.87408 7.00676 4.19752 6.74801L7.53086 4.08134C7.80477 3.86221 8.19398 3.86221 8.4679 4.08134L11.8012 6.74801C12.1247 7.00676 12.1771 7.47873 11.9184 7.80218C11.6596 8.12563 11.1876 8.17807 10.8642 7.91931L7.99938 5.62746L5.13456 7.91931Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRightEnd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-right-end.39131354e30ae54b03f011e7aedc64ba.svg";